export enum BankIdStepUpAction {
	PersonalData = "personalData",
	AccountLock = "accountLock",
	EmailChange = "emailChange",
	Deposit = "deposit",
	Withdrawal = "withdrawal",
}
